import React from "react"
import ReactDOM from "react-dom"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import config from "../package.json"
import App from "./App"
import NiceModal from "@ebay/nice-modal-react"
import { I18nextProvider } from "react-i18next"
import i18n from "./i18n"
import { QueryClient, QueryClientProvider } from "react-query"
import AuthAmplifySchema from "./login/AuthAmplifySchema"
import { Authenticator } from "@aws-amplify/ui-react"
import { Auth } from "aws-amplify"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./index.css"
import { getUserOrganizationApi } from "src/services/users"
import * as Tracker from "./common/utils/TrackingUtils"
import "src/styles/global.css"
import PublicViewSharedDocuments from "./PublicView/DocumentsSharing/PublicViewSharedDocuments"
import LoginPage from "./PublicView/Onboarding/Login"
import PasswordResetPage from "./PublicView/Onboarding/PasswordReset"
import Onboarding from "./PublicView/Onboarding/Onboarding"
import PrivateRoute from "./PublicView/Onboarding/PrivateRoute"
import CheckList from "./PublicView/Checklist/Checklist"

const queryClient = new QueryClient()

export const theme = {
  name: "my-theme",
  tokens: {
    colors: {
      background: {
        primary: { value: "#1c3841" },
      },
      font: {
        primary: { value: "black" },
        secondary: { value: "white" },
        error: { value: "#EE4B2B" },
      },
      border: {
        primary: { value: "white" },
        focus: { value: "white" },
        error: { value: "#EE4B2B" },
      },
    },
    components: {
      selectfield: {
        color: { value: "white" },
      },
    },
  },
  components: {
    select: {
      borderColor: "white",
      color: "white",
      backgroundColor: "transparent",
      _hover: {
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      },
    },
  },
}

ReactDOM.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <NiceModal.Provider>
          <Switch>
            <Route exact path="/public-view/record-documents/:uuid" render={() => <PublicViewSharedDocuments />} />
            <Route exact path="/public-view/checklist/:uuid" render={() => <CheckList />} />
            <Route exact path="/onboarding/login" render={() => <LoginPage />} />
            <Route exact path="/onboarding/reset-password" render={() => <PasswordResetPage />} />
            <Route
              path="/onboarding(/*)?"
              render={() => (
                <PrivateRoute>
                  <Onboarding />
                </PrivateRoute>
              )}
            />
            <Route
              exact
              path="/su-admin"
              render={() => {
                const stage = process.env.REACT_APP_STAGE
                let url = "https://admin-next.ecosuite.dev/root-user" // dev default
                if (stage === "test") url = "https://admin-next.ecosuitetest.io/root-user"
                if (stage === "prod") url = "https://admin-next.ecosuite.io/root-user"
                window.location.href = url
                return null
              }}
            />
            <Route
              exact
              path="/su-admin/organizations"
              render={() => {
                const stage = process.env.REACT_APP_STAGE
                let url = "https://admin-next.ecosuite.dev/root-user"
                if (stage === "test") url = "https://admin-next.ecosuitetest.io/root-user"
                if (stage === "prod") url = "https://admin-next.ecosuite.io/root-user"
                window.location.href = url
                return null
              }}
            />
            <Route
              exact
              path="/su-admin/organization/create"
              render={() => {
                const stage = process.env.REACT_APP_STAGE
                let url = "https://admin-next.ecosuite.dev/root-user"
                if (stage === "test") url = "https://admin-next.ecosuitetest.io/root-user"
                if (stage === "prod") url = "https://admin-next.ecosuite.io/root-user"
                window.location.href = url
                return null
              }}
            />
            <Route
              exact
              path="/su-admin/organization/:id"
              render={() => {
                const stage = process.env.REACT_APP_STAGE
                let url = "https://admin-next.ecosuite.dev/root-user"
                if (stage === "test") url = "https://admin-next.ecosuitetest.io/root-user"
                if (stage === "prod") url = "https://admin-next.ecosuite.io/root-user"
                window.location.href = url
                return null
              }}
            />
            <Route
              path="/*"
              render={() => (
                <Authenticator
                  services={{
                    handleSignIn({ username, password }) {
                      return Auth.signIn(username.toLowerCase(), password).then((signInOutput) => {
                        if (signInOutput.isSignedIn) {
                          getUserOrganizationApi(username).then((data) => {
                            if (data?.organization) {
                              Tracker.install(data.organization)
                            }
                          })
                        }
                        return signInOutput
                      })
                    },
                    handleSignUp(formData) {
                      return Auth.signUp({
                        ...formData,
                        username: formData.username.toLowerCase(),
                      })
                    },
                  }}
                  components={AuthAmplifySchema}
                  formFields={{
                    confirmResetPassword: {
                      confirm_password: {
                        display: "none",
                        height: 0,
                      },
                    },
                  }}
                  hideSignUp={true}
                  passwordSettings={{
                    passwordPolicyMinLength: 8,
                    passwordPolicyCharacters: ["REQUIRES_LOWERCASE", "REQUIRES_UPPERCASE", "REQUIRES_NUMBERS"],
                  }}
                >
                  {() => <App version={config.version} />}
                </Authenticator>
              )}
            />
          </Switch>
          <ToastContainer position="bottom-left" theme="colored" style={{ fontFamily: "Inter !important" }} />
        </NiceModal.Provider>
      </I18nextProvider>
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById("root"),
)
